import { render, staticRenderFns } from "./cookie-policy.vue?vue&type=template&id=4173875b&scoped=true&"
import script from "./cookie-policy.vue?vue&type=script&lang=js&"
export * from "./cookie-policy.vue?vue&type=script&lang=js&"
import style0 from "./cookie-policy.vue?vue&type=style&index=0&id=4173875b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4173875b",
  null
  
)

export default component.exports